import { BaseCartClient } from "../types/clients";
import { CartState, RawCartResponse } from "@core/types";
import { convertCartToSupaCart, convertSupaCartToCart } from "./converters";
class CartClient extends BaseCartClient {
  async updateCart(cart: CartState, shippingZone: string): Promise<CartState | null> {
    const supaCart = convertCartToSupaCart(cart);
    const { data } = await this.instance.post<RawCartResponse | null>("/wp-json/parhato-api/v1/cart", {
      ...supaCart,
      shippingZone,
    });

    return data ? convertSupaCartToCart(data) : null;
  }
}

export default CartClient;
